import Mustache from 'mustache';
import { getTranslation } from './utilities';
import InvoiceUnpaidClient from './clients/InvoiceUnpaidClient';

class InvoiceListUnpaid
{
    constructor()
    {
        this.invoiceListUnpaidClient = new InvoiceUnpaidClient();
        this.itemElementTemplate = document.querySelector('#invoiceListUnpaidItemElementTemplate').innerHTML;
        this.selector = '.js-invoice-list-unpaid';

        this.table = undefined;
    }

    init()
    {
        let self = this;

        this.table = $(this.selector).DataTable({
            ajax: {
                url: this.invoiceListUnpaidClient.uri,
                data: function(data)
                {
                    return {
                        skip: data.start,
                        take: data.length,
                        sort: self.formatOrder(self, data.order)
                    };
                },
                // dataSrc: this.invoiceListUnpaidClient.dataSrc
                dataSrc: (json) =>
                {
                    let jsonData = json[this.invoiceListUnpaidClient.dataSrc]['invoiceDetails'];
                    for (let i = 0; i < json[this.invoiceListUnpaidClient.dataSrc]['invoiceDetails'].length; i++)
                    {
                        jsonData[i].hasInvoiceDetails = json[this.invoiceListUnpaidClient.dataSrc].hasInvoiceDetails;
                        jsonData[i].balances = json[this.invoiceListUnpaidClient.dataSrc].balances;
                    }
                    return jsonData;
                }
            },
            dom:'l\
				f\
				r\
				<"invoice-list-table__scroll table--scroll-mobile"t>\
				p\
				i',
            paging: false,
            info: false,
            searching: false,
            lengthChange: false,
            language: this.datatableTexts(),
            order: [[0, 'desc']],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4],
                    orderable: false
                },
                {
                    width: '20%',
                    targets: 0,
                    class: 'invoice-list__creation_datetime',
                    render: function(data, type, row)
                    {
                        row.invoiceDate = row.invoiceDate.toString();

                        return Mustache.render(this.itemElementTemplate, {
                            invoiceListUnpaid: row,
                            invoiceListUnpaidInvoiceDate: true
                        });
                    }.bind(this)
                },
                {
                    width: '20%',
                    targets: 1,
                    class: 'invoice-list__erp_document_id text--center',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            invoiceListUnpaid: row,
                            invoiceListUnpaidNumber: true
                        });
                    }.bind(this)
                },
                {
                    width: '20%',
                    data: null,
                    targets: 2,
                    class: 'invoice-list__due-date text--center',
                    render: function(data, type, row)
                    {
                        row.dueDate = row.dueDate.toString();

                        return Mustache.render(this.itemElementTemplate, {
                            invoiceListUnpaid: row,
                            invoiceListUnpaidDueDate: true
                        });
                    }.bind(this)
                },
                {
                    width: '20%',
                    data: null,
                    targets: 3,
                    class: 'invoice-list__due-amount text--center',
                    render: function(data, type, row)
                    {
                        row.dueAmount = row.dueAmount.replace(/&euro;/g, '€');
                        return Mustache.render(this.itemElementTemplate, {
                            invoiceListUnpaid: row,
                            invoiceListUnpaidDueAmount: true
                        });
                    }.bind(this)
                },
                {
                    width: '20%',
                    targets: 4,
                    class: 'invoice-list__download text--center',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            invoiceListUnpaid: row,
                            downloadLink: true
                        });
                    }.bind(this)
                },
            ],
            footerCallback: function(row, data)
            {
                let api = this.api();
                if (data.length >= 1)
                {
                    if (self.formatedMoneyStringToInt(data[0].balances.notAssignable) >= 0)
                    {
                        $('#js-amount-plus').removeClass('hidden');
                    }
                    else
                    {
                        $('#js-amount-minus').removeClass('hidden');
                    }

                    if (self.formatedMoneyStringToInt(data[0].balances.accountBalance) >= 0)
                    {
                        $('#js-total-amount-plus').removeClass('hidden');
                    }
                    else
                    {
                        $('#js-total-amount-minus').removeClass('hidden');
                    }

                    $('tr:eq(0) td:eq(3)', api.table().footer()).html(
                        '<div class="total__total_amount credit">'
						+ '<span class="js-invoice-list-unpaid-not-assignable">'
						+ data[0].balances.notAssignable
						+ '</span></div>'
                    );

                    $('tr:eq(1) td:eq(3)', api.table().footer()).html(
                        '<div class="total__total_amount text--center">'
						+ '<span class="js-invoice-list-unpaid-account-balance">'
						+ data[0].balances.accountBalance
						+ '</span></div>'
                    );
                }
            },
            drawCallback: function()
            {
                $('#invoiceListUnpaidItemTable thead').show();
                $('#invoiceListUnpaidItemTable').eq(0)
                    .hide();
            }.bind(this),
            initComplete: function()
            {
                let isEmpty = this.table.data().count() === 0;

                if (!isEmpty)
                {
                    this.createSortSelection(this.table);
                }
            }.bind(this),
            createdRow: function(row, data)
            {
                let $row = $(row);

                $row.attr('data-erp-file-id', data.id);
            }
        });
    }

    createSortSelection(table)
    {
        let filterSection = document.createElement('div');
        let sortSelection = document.createElement('select');

        filterSection.classList.add('invoice-list-unpaid__sort', 'js-invoice-list-unpaid__sort',
            'select-button-container');

        let { 0: columns } = table.columns();

        for (let i = 0; i < columns.length; i++)
        {
            let optionText = getTranslation('content.invoice.list.unpaid.header.col.' + i);

            if (optionText)
            {
                let optionDescending = document.createElement('option');
                let optionAscending = document.createElement('option');

                optionDescending.value = columns[i] !== 0 ? columns[i] * -1 : -999;
                optionDescending.text = optionText + ' ' + getTranslation('content.invoice.list.sort.descending');
                sortSelection.appendChild(optionDescending);

                optionAscending.value = columns[i] !== 0 ? columns[i] : 999;
                optionAscending.text = optionText + ' ' + getTranslation('content.invoice.list.sort.ascending');
                sortSelection.appendChild(optionAscending);
            }
        }

        filterSection.append(sortSelection);
        document.querySelector('.js-invoice-list-unpaid_filter_sorting_section').append(filterSection);

        sortSelection.addEventListener('change', function()
        {
            if (this.value < 0)
            {
                table.order([this.value != -999 ? this.value * -1 : 0, 'desc']).draw();
            }
            else if (this.value > 0)
            {
                table.order([this.value != 999 ? this.value : 0, 'asc']).draw();
            }
            else
            {
                table.order([0, 'asc']).draw();
            }
        });
    }

    datatableTexts()
    {
        return {
            'paginate': {
                'previous': '<i class="fa-regular fa-chevron-left"></i>',
                'next': '<i class="fa-regular fa-chevron-right"></i>',
            },
            'processing': getTranslation('content.invoice.processing'),
            'loadingRecords': getTranslation('content.invoice.loading'),
            // 'info': getTranslation('content.shipmentdetails.info.entries'),
        };
    }

    formatOrder(self, order)
    {
        $(order).each(function(k)
        {
            order[k].field = self.matchOrderIdWithColumnName(order[k].column);
            order[k].dir = order[k].dir.toUpperCase();
        });

        return order;
    }

    matchOrderIdWithColumnName(orderId)
    {
        switch (orderId)
        {
        case 0:
            return 'invoiceDate';
        case 1:
            return 'erpDocumentId';
        case 2:
            return 'dueDate';
        case 3:
            return 'dueAmount';
        default:
            return null;
        }
    }

    formatedMoneyStringToInt(formattedMoney)
    {
        return parseInt(formattedMoney.replace(/(,|\.|&euro;)|€/, ''), 10);
    }
}

if (document.querySelector('.js-invoice-list') !== null)
{
    (new InvoiceListUnpaid()).init();
}
